var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1539_802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71729 11.8098L12.246 7.17261",
    stroke: "#99A1AF",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33022 3.49883L4.42363 8.50572C4.20498 8.72444 4.08215 9.02103 4.08215 9.33029C4.08215 9.63955 4.20498 9.93615 4.42363 10.1549C4.64234 10.3735 4.93894 10.4963 5.24819 10.4963C5.55745 10.4963 5.85405 10.3735 6.07276 10.1549L10.9794 5.14797C11.4166 4.71055 11.6623 4.11735 11.6623 3.49883C11.6623 2.88032 11.4166 2.28712 10.9794 1.8497C10.5419 1.4124 9.94873 1.16675 9.33022 1.16675C8.7117 1.16675 8.1185 1.4124 7.68108 1.8497L2.77391 6.856C2.11769 7.51223 1.74902 8.40225 1.74902 9.33029C1.74902 10.2583 2.11769 11.1484 2.77391 11.8046C3.43013 12.4608 4.32016 12.8295 5.24819 12.8295C6.17623 12.8295 7.06626 12.4608 7.72248 11.8046",
    stroke: "#99A1AF",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1539_802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9955,
    height: 13.9955,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayAttach);
export default __webpack_public_path__ + "static/media/gray_attach.303655c047f5c4efe0cff53f495e296c.svg";
export { ForwardRef as ReactComponent };